<div class="searchable-select position-relative">
  <!-- Main Select Button -->
  <div
    class="form-control d-flex align-items-center justify-content-between"
    [class]="getSizeClass()"
    [class.disabled]="disabled"
    [class.is-open]="isOpen"
    (click)="toggleDropdown()"
    style="cursor: pointer;">
    
    <span class="selected-text" [class.text-muted]="!selectedOption">
      {{ getDisplayText() }}
    </span>
    
    <div class="d-flex align-items-center">
      <!-- Clear Button -->
      <button 
        *ngIf="clearable && selectedOption && !disabled"
        type="button"
        class="btn btn-sm btn-icon btn-light-danger me-2"
        (click)="clearSelection(); $event.stopPropagation()"
        [title]="clearText"
        style="padding: 2px 6px; font-size: 10px;">
        <i class="ki-duotone ki-cross fs-7">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </button>
      
      <!-- Dropdown Arrow -->
      <i class="ki-duotone ki-down fs-7 text-gray-500" [class.rotate-180]="isOpen">
        <span class="path1"></span>
        <span class="path2"></span>
      </i>
    </div>
  </div>

  <!-- Dropdown Menu -->
  <div 
    *ngIf="isOpen" 
    class="dropdown-menu show position-absolute w-100 mt-1 shadow-sm border"
    style="z-index: 1050; max-height: 300px; overflow-y: auto;">
    
    <!-- Search Input -->
    <div class="px-3 py-2 border-bottom">
      <div class="position-relative">
        <i class="ki-duotone ki-magnifier fs-6 position-absolute top-50 translate-middle-y ms-3 text-gray-500">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input 
          type="text"
          class="form-control form-control-sm searchable-select-search ps-10"
          [placeholder]="searchPlaceholder"
          [value]="searchTerm"
          (input)="onSearchChange($event)"
          (click)="$event.stopPropagation()">
      </div>
    </div>

    <!-- Options List -->
    <div class="options-container">
      <!-- No Results -->
      <div *ngIf="filteredOptions.length === 0" class="px-3 py-2 text-muted text-center">
        {{ noResultsText }}
      </div>
      
      <!-- Options -->
      <a 
        *ngFor="let option of filteredOptions; trackBy: trackByValue"
        href="javascript:void(0)"
        class="dropdown-item d-flex align-items-center"
        [class.active]="option.value === selectedValue"
        [class.disabled]="option.disabled"
        (click)="selectOption(option)">
        
        <!-- Selected Indicator -->
        <i 
          *ngIf="option.value === selectedValue"
          class="ki-duotone ki-check fs-6 text-primary me-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        
        <!-- Option Label -->
        <span [class.ms-4]="option.value !== selectedValue">
          {{ option.label }}
        </span>
      </a>
    </div>
  </div>
</div>
